/* eslint-disable */

/**
 * A category of file, such as a selfie, W2, SSN card, etc. The app uses the category to determine
 * how to obtain a file: From camera vs storage, which camera to use, what focal lengths to allow,
 * which file extension(s) to use, etc.
 */
export enum FileCategory {
  /** SELFIE - A photo of the user, typically so we can match it to the photo on their government ID. */
  SELFIE = "SELFIE",
  /** PAY_STUB_FRONT - A photo of the user's pay stub, to verify their SSN/Name/DOB. */
  PAY_STUB_FRONT = "PAY_STUB_FRONT",
  /** W2_FORM_FRONT - A photo of the user's W2 form, to verify their SSN/Name/DOB. */
  W2_FORM_FRONT = "W2_FORM_FRONT",
  /** SSN_CARD_FRONT - A photo of the user's SSN card, to verify their SSN/Name/DOB. */
  SSN_CARD_FRONT = "SSN_CARD_FRONT",
  SSN_CARD_BACK = "SSN_CARD_BACK",
  /** TAX_RETURN_FRONT - A photo of the user's tax return, to verify their SSN/Name/DOB. */
  TAX_RETURN_FRONT = "TAX_RETURN_FRONT",
  /** PASSPORT_FRONT - A photo of the user's passport, to verify their identity (coupled with SELFIE). */
  PASSPORT_FRONT = "PASSPORT_FRONT",
  /** PASSPORT_CARD_FRONT - A photo of the user's passport card, to verify their identity (coupled with SELFIE). */
  PASSPORT_CARD_FRONT = "PASSPORT_CARD_FRONT",
  PASSPORT_CARD_BACK = "PASSPORT_CARD_BACK",
  /** DRIVERS_LICENSE_FRONT - A photo of the user's driver's license, to verify their identity (coupled with SELFIE). */
  DRIVERS_LICENSE_FRONT = "DRIVERS_LICENSE_FRONT",
  DRIVERS_LICENSE_BACK = "DRIVERS_LICENSE_BACK",
  /** STATE_ID_FRONT - A photo of the user's state id, to verify their identity (coupled with SELFIE). */
  STATE_ID_FRONT = "STATE_ID_FRONT",
  STATE_ID_BACK = "STATE_ID_BACK",
  /** LEXIS_FRONT - A copy of user's Lexis report. */
  LEXIS_FRONT = "LEXIS_FRONT",
  /** TRANSUNION_FRONT - A copy of user's Transunion (TLO) report. */
  TRANSUNION_FRONT = "TRANSUNION_FRONT",
  /** MILITARY_ID_FRONT - A photo of the user's military id, to verify their identity (coupled with SELFIE). */
  MILITARY_ID_FRONT = "MILITARY_ID_FRONT",
  MILITARY_ID_BACK = "MILITARY_ID_BACK",
  /** DEBIT_CARD_FRONT - A photo of the user's debit card, to verify their identity. */
  DEBIT_CARD_FRONT = "DEBIT_CARD_FRONT",
  DEBIT_CARD_BACK = "DEBIT_CARD_BACK",
  /** GOVERNMENT_ISSUED_ID_FRONT - A photo of any government issued id, eg. passport, driver's license, etc (couple with SELFIE). */
  GOVERNMENT_ISSUED_ID_FRONT = "GOVERNMENT_ISSUED_ID_FRONT",
  GOVERNMENT_ISSUED_ID_BACK = "GOVERNMENT_ISSUED_ID_BACK",
  /** CREDIT_CARD_FRONT - A photo of the user's credit card, to verify their instrument. */
  CREDIT_CARD_FRONT = "CREDIT_CARD_FRONT",
  CREDIT_CARD_BACK = "CREDIT_CARD_BACK",
  /** DIVORCE_DECREE - A photo of a legal document indicating the dissolution of a marriage. */
  DIVORCE_DECREE = "DIVORCE_DECREE",
  /** MARRIAGE_CERTIFICATE - A photo of a legal document indicating a new marriage. */
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  /** NAME_CHANGE_JUDGMENT - A photo of a document indicating a legal name change. */
  NAME_CHANGE_JUDGMENT = "NAME_CHANGE_JUDGMENT",
  /** NYC_ID_BACK - A photo of the user's NYC ID card, to verify their identity. */
  NYC_ID_BACK = "NYC_ID_BACK",
  NYC_ID_FRONT = "NYC_ID_FRONT",
  /** NYS_LEARNER_PERMIT_BACK - A photo of the user's NYS Learner Permit, to verify their identity. */
  NYS_LEARNER_PERMIT_BACK = "NYS_LEARNER_PERMIT_BACK",
  NYS_LEARNER_PERMIT_FRONT = "NYS_LEARNER_PERMIT_FRONT",
  /** NYS_NON_DRIVER_ID_BACK - A photo of the user's NYS Non-Driver ID card, to verify their identity. */
  NYS_NON_DRIVER_ID_BACK = "NYS_NON_DRIVER_ID_BACK",
  NYS_NON_DRIVER_ID_FRONT = "NYS_NON_DRIVER_ID_FRONT",
  /** RESIDENCE_PERMIT_BACK - A photo of the user's Resident card, to verify their identity. */
  RESIDENCE_PERMIT_BACK = "RESIDENCE_PERMIT_BACK",
  RESIDENCE_PERMIT_FRONT = "RESIDENCE_PERMIT_FRONT",
  /** STUDENT_ID_BACK - A photo of the user's Student ID card, to verify their identity. */
  STUDENT_ID_BACK = "STUDENT_ID_BACK",
  STUDENT_ID_FRONT = "STUDENT_ID_FRONT",
  /** CREDIT_CARD_STATEMENT_BACK - A photo of the user's recent CC statement, as secondary documentation to verify their identity. */
  CREDIT_CARD_STATEMENT_BACK = "CREDIT_CARD_STATEMENT_BACK",
  CREDIT_CARD_STATEMENT_FRONT = "CREDIT_CARD_STATEMENT_FRONT",
  /** GOVERNMENT_BENEFITS_CARD_BACK - A photo of the user's Government Benefits card, as secondary documentation to verify their identity. */
  GOVERNMENT_BENEFITS_CARD_BACK = "GOVERNMENT_BENEFITS_CARD_BACK",
  GOVERNMENT_BENEFITS_CARD_FRONT = "GOVERNMENT_BENEFITS_CARD_FRONT",
  /** UTILITY_BILL_BACK - A photo of the user's recent Utility Bill, as secondary documentation to verify their identity. */
  UTILITY_BILL_BACK = "UTILITY_BILL_BACK",
  UTILITY_BILL_FRONT = "UTILITY_BILL_FRONT",
  /** SELFIE_LEFT - A photo of the user's left and right sides of the face. */
  SELFIE_LEFT = "SELFIE_LEFT",
  SELFIE_RIGHT = "SELFIE_RIGHT",
  /** PROOF_OF_ADDRESS - Extra documentation used for proof of address. */
  PROOF_OF_ADDRESS = "PROOF_OF_ADDRESS",
}
